import { CloseIcon, InfoOutlineIcon } from "@chakra-ui/icons";
import {
  Alert,
  Box,
  Button,
  Flex,
  Modal,
  ModalContent,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import ExcelIcon from "../../../assets/images/product-list/excel-icon.png";
import "../styles/mass-discount-setup.scss";
import UploadFile from "../../common/UploadFile";
import Axios from "../../../services/axios";
import downloadFile from "../../helpers/downloadFile";

const columns = [
  { dataField: "row", text: "Baris Error", sort: true },
  {
    dataField: "error",
    text: "Kolom",
    sort: true,
  },
];

const BulkDiscountModal = ({ isOpen, onClose, refetchTable }) => {
  const toast = useToast();
  const [isDisplayReport, setIsDisplayReport] = useState(false);
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorDetail, setErrorDetail] = useState([]);
  const [totalSuccess, setTotalSuccess] = useState(0);
  const totalError = errorDetail.length;

  const handleDownload = async () => {
    try {
      const { data: response } = await Axios({
        method: "GET",
        url: "/product/discount/template",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
        responseType: "blob",
        paramsSerializer: function (query) {
          return stringify(query, { arrayFormat: "comma" });
        },
      });
      const file = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
      });
      downloadFile(file, "Template Upload Discount PBP.xlsx");
    } catch (err) {
      toast({
        title: "Error.",
        description: "Terjadi kesalahan, mohon coba lagi",
        status: "error",
        position: "top",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleSelectFile = (newFiles) => {
    setFiles(newFiles?.[0] ? [newFiles[0]] : []);
  };

  const handleUpload = async () => {
    if (!files.length) return;

    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", files[0]);

      const { data: response } = await Axios({
        url: "/product/discount/bulk-update",
        method: "POST",
        data: formData,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setErrorDetail(response?.data?.failed || []);
      setTotalSuccess(response?.data?.successCount || 0);
      refetchTable();
      setFiles([]);
      setIsDisplayReport(true);
    } catch (err) {
      toast({
        title: "Error.",
        description: "Terjadi kesalahan, mohon coba lagi",
        status: "error",
        position: "top",
        duration: 3000,
        isClosable: true,
      });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (isOpen) {
      setIsDisplayReport(false);
      setErrorDetail([]);
      setTotalSuccess(0);
    }
  }, [isOpen]);

  return (
    <Modal
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={!isLoading}
    >
      <ModalOverlay />
      <ModalContent
        maxWidth="600px"
        p="24px"
        gap="24px"
        display="flex"
        direction="column"
        alignItems="stretch"
        fontSize="14px"
      >
        <Flex gap="8px" justifyContent="space-between" alignItems="center">
          <Text fontWeight="700" fontSize="24px" color="#2A3D4A">
            {isDisplayReport ? "Report" : "Bulk Update"}
          </Text>
          {!isLoading && (
            <Box
              p="2px 8px 3px"
              border="3px solid #2A3D4A"
              borderRadius="100%"
              h="fit-content"
              w="fit-content"
              cursor="pointer"
              onClick={onClose}
            >
              <CloseIcon fontSize="10px" color="#2A3D4A" />
            </Box>
          )}
        </Flex>
        {isDisplayReport ? (
          <>
            {totalSuccess > 0 && (
              <Alert
                status="success"
                borderRadius="4px"
                gap="12px"
                color="#33995E"
                backgroundColor="#D9F2E3"
                fontWeight="600"
              >
                <InfoOutlineIcon />
                {totalSuccess} Baris Berhasil Diupload
              </Alert>
            )}
            {totalError > 0 && (
              <>
                <Alert
                  status="error"
                  borderRadius="4px"
                  gap="12px"
                  color="#E6001C"
                  backgroundColor="#FFEDEF"
                  alignItems="flex-start"
                  fontWeight="600"
                >
                  <InfoOutlineIcon mt="2px" />
                  <Flex direction={"column"}>
                    {totalError} Baris Gagal Diupload
                    <Text color="#2A3D4A" fontWeight="400">
                      Pastikan kamu sudah mengoreksi{" "}
                      <Text as="span" fontWeight="700">
                        Baris Error
                      </Text>{" "}
                      sebelum melakukan Bulk Update berikutnya
                    </Text>
                  </Flex>
                </Alert>
                <ToolkitProvider
                  data={errorDetail}
                  columns={columns}
                  keyField="row"
                  search
                >
                  {(props) => (
                    <Box className="bulk-modal-error__table-container">
                      <BootstrapTable
                        {...props.baseProps}
                        bootstrap4={true}
                        bordered={false}
                      />
                    </Box>
                  )}
                </ToolkitProvider>
              </>
            )}
          </>
        ) : (
          <>
            <Flex gap="8px" direction="column">
              <Text fontWeight="700" color={isLoading ? "#ADADAD" : "#2A3D4A"}>
                Template
              </Text>
              <Button
                variant="link"
                disabled={isLoading}
                color={isLoading ? "#ADADAD" : "#0056CC"}
                w="max-content"
                onClick={handleDownload}
              >
                <img alt="" src={ExcelIcon} style={{ height: 32 }} />
                <Text fontWeight="500" fontSize="16px" color="inherit">
                  Download Template Discount Setup
                </Text>
              </Button>
            </Flex>
            <Flex gap="8px" direction="column">
              <Text fontWeight="700" color={isLoading ? "#ADADAD" : "#2A3D4A"}>
                Upload File
              </Text>
              <UploadFile
                files={files}
                handleSelectFile={handleSelectFile}
                isDisabled={isLoading}
                maxFiles={1}
              />
            </Flex>

            <Flex gap="16px" direction="column">
              <Flex gap="8px">
                <InfoOutlineIcon mt="4px" />
                <Text color="#2A3D4A">
                  Pastikan file yang kamu upload sudah mengikuti standardisasi
                  Template Discount Setup di atas
                </Text>
              </Flex>
              <Button
                className="modal-save__button"
                onClick={handleUpload}
                disabled={!files.length || isLoading}
                isLoading={isLoading}
              >
                Upload
              </Button>
            </Flex>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default BulkDiscountModal;
